/* eslint-disable @typescript-eslint/no-empty-function */
import { NgClass } from '@angular/common';
import { Component, Input, Output, EventEmitter, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-three-state-toggle',
  templateUrl: './three-state-toggle.component.html',
  styleUrls: ['./three-state-toggle.component.css'],
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ThreeStateToggleComponent),
      multi: true,
    },
  ],
})
export class ThreeStateToggleComponent implements ControlValueAccessor {
  @Input() public state?: boolean = undefined;
  @Input() public disabled = false;
  @Input() public textTrue = 'Not Empty';
  @Input() public textFalse = 'Empty';
  @Input() public textNull = '-';
  @Output() public stateChange = new EventEmitter<boolean | null>();

  public toggleState(): void {
    if (this.state === undefined) {
      this.state = true;
    } else if (this.state === true) {
      this.state = false;
    } else {
      this.state = undefined;
    }
    this.onChange(this.state);
    this.stateChange.emit(this.state);
  }

  public writeValue(value?: boolean): void {
    this.state = value;
  }

  public registerOnChange(fn: (value?: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    console.debug(isDisabled);
    // Optional: Handle disabled state if needed
  }

  private onChange: (value?: boolean) => void = () => {};
  private onTouched: () => void = () => {};
}
